import { buildClassName } from './buildClassName';
import type { PaintOption } from '../types';

export interface PaintSwatchGroupProps {
  options: PaintOption[];
  selectedOptionId: string;
  onOptionSelect: (optionId: string) => void;
  /** 이동 모드에서 차량 사양을 잠글 때 true. */
  disabled?: boolean;
}

export function PaintSwatchGroup({
  options,
  selectedOptionId,
  onOptionSelect,
  disabled = false,
}: PaintSwatchGroupProps) {
  return (
    <ul className="swatch-list" aria-label="외장 색상 선택">
      {options.map((option) => {
        const isSelected = option.id === selectedOptionId;
        return (
          <li key={option.id}>
            <button
              type="button"
              className={buildClassName('swatch', 'swatch--selected', isSelected)}
              aria-pressed={isSelected}
              aria-label={option.name}
              title={option.name}
              disabled={disabled}
              onClick={() => onOptionSelect(option.id)}
            >
              <span className="swatch__color" style={{ backgroundColor: option.hex }} />
            </button>
          </li>
        );
      })}
    </ul>
  );
}
